var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:rupee"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 3.5H18L17 5.5H13.74C14.22 6.08 14.58 6.76 14.79 7.5H18L17 9.5H15C14.8761 10.7468 14.3345 11.9151 13.4632 12.8154C12.592 13.7157 11.442 14.2953 10.2 14.46V14.5H9.5L15.5 21.5H13L7 14.5V12.5H9.5C11.26 12.5 12.72 11.2 12.96 9.5H7L8 7.5H12.66C12.1 6.32 10.9 5.5 9.5 5.5H7L8 3.5Z",
    fill: "#4555BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiRupee);
export default __webpack_public_path__ + "static/media/mdi_rupee.ec1f7be036329321acfa66ed3e120e8b.svg";
export { ForwardRef as ReactComponent };